import React from "react";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import { Space, Row } from "@masterteam/mt-design-react";

import useIsAr from "../../Hooks/useIsAr";
import { formatDate } from "../../helpers";

import "./style.scss";

const InitiativeOverview = ({ data }) => {
  const [isAr, locale] = useIsAr();

  return (
    <Space
      direction="vertical"
      className="overview-container"
      size="large"
      gap="36px"
    >
      <Space direction="vertical" className="item" gap="4px" key="description">
        <FormattedMessage id="initiative.description" />
        <p>{isAr ? data?.ArabicDescription : data?.EnglishDescription}</p>
      </Space>

      <Row justify="between" style={{ width: "75%" }}>
        <Space direction="vertical" className="item" gap="4px" key="duration">
          <FormattedMessage id="initiative.duration" />
          <p>
            {data?.Duration} <FormattedMessage id="common.months" />
          </p>
        </Space>

        <Space direction="vertical" className="item" gap="4px" key="department">
          <FormattedMessage id="common.department" />
          <p>
            {isAr
              ? data?.Department?.ArabicName
              : data?.Department?.EnglishName}
          </p>
        </Space>

        <Space direction="vertical" className="item" gap="4px">
          <FormattedMessage id="delegations.start-date" />
          <p>{moment(data?.StartDate).locale(locale).format("DD-MM-YYYY")}</p>
        </Space>
      </Row>

      <Space direction="vertical" className="item" gap="12px">
        <FormattedMessage id="initiative.related-strategic-objective" />
        <Space size="small" className="value-wrapper">
          <div className="box code">{data?.StrategicObjective?.Code}</div>
          <div className="box value">
            {isAr
              ? data?.StrategicObjective?.ArabicName
              : data?.StrategicObjective?.EnglishName}
          </div>
        </Space>
      </Space>

      <Space direction="vertical" className="item" gap="12px">
        <FormattedMessage id="initiative.related-objective-attributes" />

        <Space direction="vertical">
          {data?.Attributes?.map((item) => (
            <Space size="small" className="value-wrapper">
              <div className="box code">{item?.Code}</div>
              <div className="box value">
                {isAr ? item?.ArabicName : item?.EnglishName}
              </div>
            </Space>
          ))}
        </Space>
      </Space>

      <Space direction="vertical" className="item" gap="12px">
        <FormattedMessage id="initiative.related-strategic-kpis" />
        {data?.KPIs?.length ? (
          <Space size="small" direction="vertical">
            {data?.KPIs?.map((e, i) => (
              <Space size="small" className="value-wrapper" key={i}>
                <div
                  className="box code"
                  style={{ backgroundColor: i % 2 !== 0 && "#f1f7f7" }}
                >
                  {e?.Code}
                </div>
                <div
                  className="box value"
                  style={{ backgroundColor: i % 2 !== 0 && "#f1f7f7" }}
                >
                  {isAr ? e?.ArabicName : e?.EnglishName}
                </div>
              </Space>
            ))}
          </Space>
        ) : (
          <div>{"---"}</div>
        )}
      </Space>

      <Space direction="vertical" className="item" gap="12px">
        <FormattedMessage id="initiative.related-other-initiatives" />
        {data?.Initiatives?.length ? (
          <Space size="small" direction="vertical">
            {data?.Initiatives?.map((e, i) => (
              <Space size="small" className="value-wrapper" key={i}>
                <div
                  className="box code"
                  style={{ backgroundColor: i % 2 !== 0 && "#f1f7f7" }}
                >
                  {e?.Code}
                </div>
                <div
                  className="box value"
                  style={{ backgroundColor: i % 2 !== 0 && "#f1f7f7" }}
                >
                  {isAr ? e?.ArabicName : e?.EnglishName}
                </div>
              </Space>
            ))}
          </Space>
        ) : (
          <div>{"---"}</div>
        )}
      </Space>
    </Space>
  );
};
export default InitiativeOverview;
